import angular from 'angular';

/**
 * @ngdoc function
 * @name myConsultApp.controller:editOrganization
 * @description
 * # viewOrganizations
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller(
    'editOrganizationSettings',
    (
      $scope,
      $rootScope,
      $route,
      $routeParams,
      $location,
      crumble,
      ManageOrganizationService,
      OrganizationsService,
      $timeout,
      UserService,
    ) => {
      if ($scope.isAdminUser || $scope.isSuperUser) {
        $location.path('/admin');
      }
      $scope.statesList = null;
      $scope.geoError = false;
      $scope.crumble = crumble;
      $scope.tiggerInput = false;
      $scope.solensiaInput = false;
      $scope.librelaInput = false;
      crumble.update();

      $scope.org = {
        id: $scope.currentOrganization.id,
      };
      $scope.orgData = { organization: {} };
      $scope.orgDataCopy = { organization: {} };

      $scope.formcheckDirty = false; // For hide popup of form dirty confirmation default

      $scope.error = {
        status: false,
        details: '',
        highlightedFields: {},
        directoryMsg: false,
      };

      let currentForm = 'editOrgInformation';

      $scope.orgData.organization.zipcode = ''; // Set inital value to blank

      $scope.tab = {
        id: 'editOrgInformation',
        current: '',
      };

      $scope.orgDirTypes = [
        {
          name: 'Clinic',
          id: 1,
          slug: 'clinic',
        },
        {
          name: 'Shelter',
          id: 2,
          slug: 'shelter',
        },
      ];

      $scope.submit = {
        success: false,
      };

      $scope.optOutTextRequired = false;

      $scope.logo = null;
      $scope.logoUploading = false;
      $scope.invalidLogo = null;

      $scope.enrollCatPainIQ = false;
      $scope.enrollSolensia = false;
      $scope.enrollLibrela = false;

      // Function for switch tab with check forms dirty
      $scope.tabChanges = (param) => {
        if (param === 'editOrgAssociateInfo' || $scope.tab.id === 'editOrgAssociateInfo') {
          // No for validation
          $scope.tab.id = param;
          window.scrollTo(0, 0);
          $scope.error.status = false;
        } else if (param === 'ok') {
          $scope.formcheckDirty = false;
          $scope.tab.id = $scope.tab.current;
          $scope.tab.current = '';
          $scope.orgData = angular.copy($scope.orgDataCopy);
          $scope[currentForm].$setPristine();
          $scope[currentForm].$setUntouched();
          $scope.error.status = false;
          window.scrollTo(0, 0);
          $scope.updatePath();
        } else if ($scope[currentForm] && $scope[currentForm].$dirty) {
          $scope.formcheckDirty = true;
          $scope.tab.current = param;
        } else {
          $scope.tab.id = param;
          currentForm = param;
          $scope.error.status = false;
          window.scrollTo(0, 0);
          $scope.updatePath();
        }
      };

      $scope.updatePath = () => {
        $location.search({ tab: $scope.tab.id });
      };
      let params = $location.search();
      if (params.tab) {
        $scope.tab = { id: params.tab };
        $scope.tabChanges(params.tab);
      }

      // Add select organization directory type to orgData
      $scope.selectOrgDir = (orgDirType) => {
        const index = $scope.orgData.organization.directory_type
          .map((i) => i.id)
          .indexOf(orgDirType.id);

        if (index < 0) {
          $scope.orgData.organization.directory_type.push(orgDirType);
        } else if ($scope.orgData.organization.directory_type[index].is_active === true) {
          $scope.orgData.organization.directory_type.splice(index, 1);
        } else {
          $scope.orgData.organization.directory_type[index].is_active = true;
        }
      };

      // Set selected organization directory type
      $scope.setOrgDir = (orgDirType) => {
        if (
          $scope.orgData &&
          $scope.orgData.organization &&
          $scope.orgData.organization.directory_type
        ) {
          const index = $scope.orgData.organization.directory_type
            .map((i) => i.id)
            .indexOf(orgDirType.id);

          if (index < 0) {
            return false;
          }

          if ($scope.orgData.organization.directory_type[index].is_active === true) {
            return true;
          }
        }
        return false;
      };

      $scope.selectState = (option, state) => {
        if (state.abbreviation !== undefined) {
          if (state.name && option.name === state.name) {
            return true;
          }

          return state.abbreviation && option.abbreviation === state.abbreviation;
        }
      };

      $scope.goToPage = (url) => {
        ManageOrganizationService.getNewOrganizationUsersByUrl(url).then((result) => {
          $scope.usersData = result.identities;
          $scope.paginationData = result;
        });
      };

      $scope.setSort = (key) => {
        if ($scope.currentSort.label === key) {
          $scope.currentSort.key = $scope.currentSort.sortReverse ? key : '-' + key;
          $scope.currentSort.label = key;
          $scope.currentSort.sortReverse = !$scope.currentSort.sortReverse;
        } else {
          $scope.currentSort.key = key === 'last_name' ? key : '-' + key;
          $scope.currentSort.label = key;
          $scope.currentSort.sortReverse = true;
        }

        // Search for Org Users
        $scope.submitFindAUser();
      };

      $scope.getMatchingState = (option) => {
        if ($scope.orgData.organization.state) {
          if (
            option.abbreviation &&
            option.abbreviation === $scope.orgData.organization.state.abbreviation
          ) {
            return true;
          }

          return option.name && option.name === $scope.orgData.organization.state.name;
        }

        return false;
      };

      // Get Geocoding for Address, City, State, Zip(required)
      $scope.getGeoCode = (field) => {
        if (
          (field === 'zipcode' &&
            $scope.orgDataRecord.zipcode !== $scope.orgData.organization.zipcode) ||
          (field === 'city' &&
            $scope.orgDataRecord.city.name !== $scope.orgData.organization.city.name) ||
          (field === 'state' &&
            $scope.orgDataRecord.state.name !== $scope.orgData.organization.state.name) ||
          (field === 'address' &&
            $scope.orgDataRecord.address_1 !== $scope.orgData.organization.address_1)
        ) {
          let tmpAdd = [];
          if ($scope.orgData.organization.address_1)
            tmpAdd.push($scope.orgData.organization.address_1);
          if ($scope.orgData.organization.address_2)
            tmpAdd.push($scope.orgData.organization.address_2);
          if (
            field === 'state' &&
            $scope.orgDataRecord.state.name !== $scope.orgData.organization.state.name
          ) {
            const index = $scope.statesList
              .map((i) => i.name)
              .indexOf($scope.orgData.organization.state.name);
            if (index > 0) {
              $scope.orgData.organization.state = {
                name: $scope.statesList[index].name,
                abbreviation: $scope.statesList[index].abbreviation,
                country: $scope.statesList[index].country,
              };
            }
          }

          let address;
          if (field === 'zipcode') {
            address = {
              address: tmpAdd.toString(),
              city: '',
              state: '',
              zipcode: $scope.orgData.organization.zipcode,
            };
          } else if (field === 'city') {
            address = {
              address: tmpAdd.toString(),
              city: $scope.orgData.organization.city.name,
              state: '',
              zipcode: $scope.orgData.organization.zipcode,
            };
          } else {
            address = {
              address: tmpAdd.toString(),
              city: $scope.orgData.organization.city.name,
              state: $scope.orgData.organization.state.abbreviation,
              zipcode: $scope.orgData.organization.zipcode,
            };
          }

          ManageOrganizationService.getGeocode(address).then(
            (res) => {
              $scope.orgData.organization.latitude = res.geocoding.latitude;
              $scope.orgData.organization.longitude = res.geocoding.longitude;
              if (
                field === 'city' &&
                res.geocoding.city !== $scope.orgData.organization.city.name
              ) {
                $scope.orgData.organization.latitude = '';
                $scope.orgData.organization.longitude = '';
                $scope.geoError =
                  'The coordinates for this address could not be found. Please try changing the city or manually populate the latitude and longitude for this organization.';
              } else {
                $scope.orgData.organization.city.name = res.geocoding.city;
              }
              if (
                field === 'state' &&
                res.geocoding.state !== $scope.orgData.organization.state.abbreviation
              ) {
                $scope.orgData.organization.latitude = '';
                $scope.orgData.organization.longitude = '';
                $scope.orgData.organization.city.name = $scope.orgDataRecord.city.name;
                $scope.geoError =
                  'The coordinates for this address could not be found. Please try changing the state or manually populate the latitude and longitude for this organization.';
              } else {
                const index = $scope.statesList
                  .map((i) => i.abbreviation)
                  .indexOf(res.geocoding.state);
                if (index > 0) {
                  $scope.orgData.organization.state = {
                    name: $scope.statesList[index].name,
                    abbreviation: res.geocoding.state,
                    country: $scope.statesList[index].country,
                  };
                } else {
                  $scope.orgData.organization.state = { abbreviation: res.geocoding.state };
                }
              }
              if (
                field === 'zipcode' &&
                res.geocoding.zipcode !== $scope.orgData.organization.zipcode
              ) {
                $scope.orgData.organization.latitude = '';
                $scope.orgData.organization.longitude = '';
                $scope.geoError =
                  'The coordinates for this address could not be found. Please try changing the zip code or manually populate the latitude and longitude for this organization.';
              }
              $scope.orgDataRecord = angular.copy($scope.orgData.organization);
            },
            () => {},
          );
        }
      };

      $scope.updateOrganization = (formId) => {
        let orgDataTabwise = {
          organization: {},
        };
        $scope.error.directoryMsg = false;
        angular.element.each(angular.element('#' + formId).serializeArray(), (_, kv) => {
          orgDataTabwise.organization.directory_type = [];
          angular.element('.directoryType:checked').each((index, ele) => {
            if ($(ele).val() === 'shelter') {
              orgDataTabwise.organization.directory_type.push($scope.orgDirTypes[1]);
            }
            if ($(ele).val() === 'clinic') {
              orgDataTabwise.organization.directory_type.push($scope.orgDirTypes[0]);
            }
          });

          if (
            kv.name === 'appointment_link' ||
            kv.name === 'twitter' ||
            kv.name === 'facebook' ||
            kv.name === 'url' ||
            kv.name === 'linkedin'
          ) {
            if (kv.value === '') orgDataTabwise.organization[kv.name] = null;
            else orgDataTabwise.organization[kv.name] = kv.value;
          } else if (orgDataTabwise.organization.hasOwnProperty(kv.name)) {
            orgDataTabwise.organization[kv.name] = $.makeArray(orgDataTabwise[kv.name]);
            orgDataTabwise.organization[kv.name].push(kv.value);
          } else {
            orgDataTabwise.organization[kv.name] = kv.value;
          }
        });
        if (formId === 'subForm' && orgDataTabwise.organization.applications === undefined) {
          orgDataTabwise.organization.applications = [];
        }
        if ($scope.enrollCatPainIQ) {
          orgDataTabwise.organization.applications.push({
            slug: 'tigger',
            is_active: true,
          });
        }

        if ($scope.enrollSolensia) {
          orgDataTabwise.organization.applications.push({
            slug: 'solensia',
            is_active: true,
          });
        }

        if ($scope.enrollLibrela) {
          orgDataTabwise.organization.applications.push({
            slug: 'librela-iep',
            is_active: true,
          });
        }

        orgDataTabwise.organization.id = $scope.org.id;
        let updateData = angular.copy(orgDataTabwise);

        $scope.error.status = false;

        function processOrgData(callback) {
          // Replace Null with Blanks
          Object.keys(updateData.organization).forEach((key) => {
            if (key.toLowerCase() === 'logo') {
              delete updateData.organization[key];
            }
            if (key.toLowerCase() === 'tigger_notification_email') {
              if (
                ($scope.tiggerInput || $scope.enrollCatPainIQ) &&
                $scope.orgData.organization.tigger_notification_email
              ) {
                updateData.organization.tigger_notification_email =
                  $scope.orgData.organization.tigger_notification_email;
                updateData.organization.tigger_notification_opt_in = true;
              } else {
                updateData.organization.tigger_notification_email = null;
                updateData.organization.tigger_notification_opt_in = false;
              }
            }
            if (key.toLowerCase() === 'solensia_notification_email') {
              if (
                ($scope.solensiaInput || $scope.enrollSolensia) &&
                $scope.orgData.organization.solensia_notification_email
              ) {
                updateData.organization.solensia_notification_email =
                  $scope.orgData.organization.solensia_notification_email;
                updateData.organization.solensia_notification_opt_in = true;
              } else {
                updateData.organization.solensia_notification_email = null;
                updateData.organization.solensia_notification_opt_in = false;
              }
            }
            if (key.toLowerCase() === 'librela_notification_email') {
              if (
                ($scope.librelaInput || $scope.enrollLibrela) &&
                $scope.orgData.organization.librela_notification_email
              ) {
                updateData.organization.librela_notification_email =
                  $scope.orgData.organization.librela_notification_email;
                updateData.organization.librela_notification_opt_in = true;
              } else {
                updateData.organization.librela_notification_email = null;
                updateData.organization.librela_notification_opt_in = false;
              }
            }
            if (key.toLowerCase() === 'state') {
              updateData.organization.state = $scope.orgData.organization.state.name;
            }
            if (
              key.toLowerCase() === 'phone' &&
              (updateData.organization[key] === null || updateData.organization[key] === '')
            ) {
              // need to retain null value in the case that someone is deleting the phone number
              updateData.organization[key] = null;
            } else if (
              (key.toLowerCase() === 'antech_id' ||
                key.toLowerCase() === 'quest_id' ||
                key.toLowerCase() === 'vetdata_code' ||
                key.toLowerCase() === 'vetdata_id') &&
              (updateData.organization[key] === null ||
                updateData.organization[key] === '' ||
                updateData.organization[key] === 'Vetdata Code is not valid')
            ) {
              updateData.organization[key] = null;
            } else if (updateData.organization.url || updateData.organization.appointment_link) {
              if (updateData.organization.url) {
                if (
                  updateData.organization.url.indexOf('http://') < 0 &&
                  updateData.organization.url.indexOf('https://') < 0
                ) {
                  updateData.organization.url = 'http://' + updateData.organization.url;
                }
              }
              if (updateData.organization.appointment_link) {
                if (
                  updateData.organization.appointment_link.indexOf('http://') < 0 &&
                  updateData.organization.appointment_link.indexOf('https://') < 0
                ) {
                  updateData.organization.appointment_link =
                    'http://' + updateData.organization.appointment_link;
                }
              }
            }
          });

          if (typeof callback === 'function') callback();
        }

        function updateOrg() {
          $scope.error.status = false;
          $scope.error.highlightedFields = {};

          if (
            $scope.orgData.organization.general_opt_out_link &&
            !$scope.orgData.organization.general_opt_out_text
          ) {
            $scope.optOutTextRequired = true;
            return;
          }

          OrganizationsService.saveProviderSettings($scope.currentOrganization.id, updateData).then(
            (response) => {
              angular.forEach($scope.orgData.organization, (value, key) => {
                if (value === '') {
                  $scope.orgData.organization[key] = $scope.currentOrganization[key];
                }
              });
              // check if code id value changed
              if ($scope.orgData.organization.vetdata_code !== response.organization.vetdata_code) {
                // assign vetdata code to the form model
                $scope.orgData.organization.vetdata_code = response.organization.vetdata_code;
              }

              angular.forEach($scope.vetOrganizations, (org) => {
                if (org.id === $scope.currentOrganization.id) {
                  $scope.currentOrganization.directory_type =
                    $scope.orgData.organization.directory_type;
                }
              });
              OrganizationsService.getOrganizations().then((organizations) => {
                if (organizations.length > 0) {
                  UserService.setVetOrganizations(organizations);
                  angular.forEach(organizations, (organization) => {
                    if (organization.id === $scope.currentOrganization.id) {
                      UserService.setCurrentOrganization(organization);
                    }
                  });
                }
              });
              $scope.submit.success = true;
            },
            (response) => {
              angular.forEach(response.data.organization, (value, key) => {
                $scope.showErrorMessage = true;
                $scope.error.highlightedFields[key] = value
                  .toString()
                  .replace(/\[\"/, '')
                  .replace(/\"\]/, '');
                $timeout(() => {
                  $scope.showErrorMessage = false;
                }, 3000);
              });
            },
          );
        }

        processOrgData(updateOrg);
      };

      $scope.reloadRoute = () => {
        $scope.submit.success = false;
        $route.reload();
      };

      $scope.getOrgInfo = () => {
        OrganizationsService.getProviderSettings($scope.currentOrganization.id).then((response) => {
          angular.forEach(response, (value, key) => {
            if (value && key !== 'directory_type' && key !== 'logo') {
              $scope.orgData.organization[key] = value;
            }
          });
          if ($scope.orgData.organization.appointment_email === null) {
            $scope.orgData.organization.appointment_email = $scope.currentOrganization.email;
          }
        });
      };

      // View is loaded
      $scope.$on('$viewContentLoaded', () => {
        // Get states list
        ManageOrganizationService.getStates().then(
          (res) => {
            $scope.stateListBind = res.states;
            $scope.statesList = angular.copy($scope.stateListBind);
          },
          () => {},
        );

        ManageOrganizationService.getOrganizationDetails($scope.org).then((result) => {
          $scope.orgData = result;
          $scope.orgData.directory_type = $scope.orgData.organization.directory_type;
          $scope.orgDataRecord = angular.copy($scope.orgData.organization);
          $scope.solensiaInput = $scope.orgData.organization.applications.some(
            (app) => app.slug === 'solensia',
          );
          $scope.librelaInput = $scope.orgData.organization.applications.some(
            (app) => app.slug === 'librela-iep',
          );
          $scope.tiggerInput = $scope.orgData.organization.applications.some(
            (app) => app.slug === 'tigger' && app.is_active === true,
          );
          $scope.orgData.organization.tigger_notification_email = $scope.tiggerInput
            ? $scope.orgData.organization.tigger_notification_email
            : null;
          $scope.orgData.organization.tigger_notification_opt_in = $scope.tiggerInput
            ? $scope.orgData.organization.tigger_notification_opt_in
            : null;
          $scope.orgData.organization.solensia_notification_email = $scope.solensiaInput
            ? $scope.orgData.organization.solensia_notification_email
            : null;
          $scope.orgData.organization.solensia_notification_opt_in = $scope.solensiaInput
            ? $scope.orgData.organization.solensia_notification_opt_in
            : null;
          $scope.orgData.organization.librela_notification_email = $scope.librelaInput
            ? $scope.orgData.organization.librela_notification_email
            : null;
          $scope.orgData.organization.librela_notification_opt_in = $scope.librelaInput
            ? $scope.orgData.organization.librela_notification_opt_in
            : null;
          $scope.orgDataCopy = angular.copy($scope.orgData);
        });

        $scope.getOrgInfo();
      });

      /* Watch ZipCode change to get GeoCode data */
      $scope.$watch('orgData.organization.zipcode', (newVal, oldVal) => {
        if (
          newVal &&
          oldVal &&
          newVal !== oldVal &&
          (newVal.length === 5 || newVal.length === 10)
        ) {
          $scope.getGeoCode('zipcode');
        }
      });

      $scope.crumbleGenerated = false;
      $scope.generatingCrumble = () => {
        if ($scope.orgData.organization.name && !$scope.crumbleGenerated) {
          crumble.update();
          $scope.crumble = crumble;
          $scope.crumble.trail[2].label = 'Edit ' + $scope.orgData.organization.name;
          $rootScope.crumble = $scope.crumble;
          $scope.crumbleGenerated = true;
          return true;
        }

        return $scope.crumbleGenerated;
      };

      $scope.onUploadLogo = (logo) => {
        $scope.error.highlightedFields.logo = null;
        $scope.logo = logo;
        $scope.logoUploading = true;
        OrganizationsService.uploadLogo($scope.org.id, logo)
          .then(({ data }) => {
            $scope.orgData.organization.logo = data.organization.tokenized_logo_url;
          })
          .catch(({ data }) => {
            console.log(data);
            $scope.error.highlightedFields.logo =
              data?.organization?.detail?.detail || data.organizations[0];
          })
          .finally(() => {
            $scope.logo = null;
            $scope.logoUploading = false;
          });
      };

      $scope.onDeleteLogo = () => {
        $scope.logoDeleting = true;
        OrganizationsService.deleteLogo($scope.org.id)
          .then(() => {
            $scope.orgData.organization.logo = null;
          })
          .finally(() => {
            $scope.logoDeleting = false;
          });
      };

      $scope.setEnrollCatPainIQ = (value) => {
        $scope.enrollCatPainIQ = value;
      };

      $scope.setEnrollLibrela = (value) => {
        $scope.enrollLibrela = value;
      };

      $scope.setEnrollSolensia = (value) => {
        $scope.enrollSolensia = value;
      };
    },
  );
